import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { nameof } from '../../../../utils/nameof';
import { CheckBox } from '../../../check-box/check-box';
import { Table } from '../../../table/table';

interface Props {
  checked?: boolean;
  disabled: boolean;
  onSelectionChanged: (selected: boolean) => void;
}

const HeaderRow = React.memo((props: Props) => {
  const { t } = useTranslation();
  const checkBoxRef = React.useRef<HTMLInputElement>(null);
  const { onSelectionChanged: propsOnSelectionChanged } = props;

  const onCheckBoxCellClick = () => {
    checkBoxRef.current?.click();
  };

  const onCheckBoxChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (!e.target.indeterminate) {
        propsOnSelectionChanged(e.target.checked);
      }
    },
    [propsOnSelectionChanged],
  );

  return (
    <Component>
      <Table.HeaderCell
        padding={{ left: 0.7, right: 0.7 }}
        shrink={true}
        onClick={props.disabled ? undefined : onCheckBoxCellClick}
        onHoverBackgroundColor={'#EEE'}
      >
        <CheckBox
          checked={props.checked}
          disabled={props.disabled}
          ref={checkBoxRef}
          onChange={onCheckBoxChange}
        />
      </Table.HeaderCell>

      <Table.HeaderCell padding={{ left: 0.4 }}>
        {t('fileManager.folderTagsDialog.nameColumn', { ns: 'components' })}
      </Table.HeaderCell>
    </Component>
  );
});

HeaderRow.displayName = nameof({ HeaderRow });

const Component = styled(Table.Row)``;

export { HeaderRow };
